export default function UpgradeAccountIcon() {
  return (
    <svg
      width='312'
      height='290'
      viewBox='0 0 312 290'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M215.919 254.246H189.42V254.446H215.919V254.246Z'
        fill='#EBEBEB'
      />
      <path
        d='M260.979 246.417H216.521V246.617H260.979V246.417Z'
        fill='#EBEBEB'
      />
      <path
        d='M188.624 246.815H173.27V247.015H188.624V246.815Z'
        fill='#EBEBEB'
      />
      <path
        d='M44.6996 260.661H39.6328V260.861H44.6996V260.661Z'
        fill='#EBEBEB'
      />
      <path
        d='M71.0209 33.0793H77.1038C77.5742 33.0793 77.9526 33.4577 77.9526 33.9234V253.996H87.1509V33.9234C87.1509 33.4577 87.5293 33.0793 87.995 33.0793H94.0778C94.8347 33.0793 95.2139 32.1632 94.6762 31.6312L83.1506 20.1056C82.8178 19.7728 82.2809 19.7728 81.9537 20.1056L70.4225 31.6312C69.8905 32.1632 70.2689 33.0793 71.0209 33.0793Z'
        fill='#EBEBEB'
      />
      <path
        d='M17.8919 140.423H31.2536C32.2881 140.423 33.1194 141.254 33.1194 142.278V191.494H53.3248V142.278C53.3248 141.255 54.1569 140.423 55.1793 140.423H68.5411C70.2044 140.423 71.0365 138.412 69.8564 137.243L44.5378 111.924C43.8073 111.194 42.6272 111.194 41.908 111.924L16.5782 137.243C15.4085 138.412 16.2397 140.423 17.8919 140.423Z'
        fill='#EBEBEB'
      />
      <path
        d='M155.999 290C241.671 290 311.122 285.944 311.122 280.941C311.122 275.938 241.671 271.882 155.999 271.882C70.3276 271.882 0.876953 275.938 0.876953 280.941C0.876953 285.944 70.3276 290 155.999 290Z'
        fill='#F5F5F5'
      />
      <path
        d='M174.984 108.585C170.816 110.65 162.111 114.306 153.935 113.722C151.926 113.578 149.95 113.186 148.086 112.442C145.406 111.378 143.702 108.673 142.686 105.089C138.982 92.1363 144.166 67.6865 144.166 67.6865C151.702 68.9186 158.983 98.3047 161.831 99.9129C164.679 101.521 176.8 100.961 176.8 100.961L177.2 104.553C177.384 106.233 176.496 107.841 174.984 108.585Z'
        fill='#316CF4'
      />
      <path
        opacity='0.3'
        d='M153.934 113.724C151.926 113.58 149.95 113.188 148.086 112.444C145.406 111.38 143.702 108.676 142.686 105.091C142.974 103.155 143.318 101.787 143.318 101.787L157.175 97.8027C157.175 97.8027 157.751 107.811 153.934 113.724Z'
        fill='#0D1333'
      />
      <path
        d='M143.076 274.651L149.771 275.358L151.027 260.919L144.333 260.212L143.076 274.651Z'
        fill='#B97964'
      />
      <path
        d='M109.668 274.162H116.154L116.69 259.136H110.196L109.668 274.162Z'
        fill='#B97964'
      />
      <path
        d='M117.052 273.412H109.171C108.906 273.414 108.676 273.599 108.619 273.858L107.339 279.634C107.23 280.151 107.56 280.659 108.078 280.769C108.147 280.783 108.218 280.79 108.288 280.79C110.838 280.748 112.695 280.591 115.897 280.591C117.869 280.591 123.819 280.798 126.542 280.798C129.264 280.798 129.619 278.108 128.506 277.86C123.505 276.77 119.742 275.261 118.141 273.824C117.845 273.553 117.454 273.405 117.052 273.412Z'
        fill='#0D1333'
      />
      <path
        d='M117.492 274.312C117.431 274.296 117.385 274.243 117.377 274.18C117.367 274.119 117.397 274.059 117.451 274.031C117.683 273.882 119.779 272.595 120.496 272.966C120.661 273.045 120.765 273.213 120.76 273.395C120.804 273.707 120.682 274.02 120.439 274.22C120.073 274.469 119.633 274.586 119.193 274.55C118.619 274.534 118.048 274.454 117.492 274.312ZM117.938 274.097C118.695 274.352 119.52 274.311 120.248 273.982C120.404 273.842 120.48 273.636 120.455 273.429C120.447 273.305 120.397 273.247 120.356 273.247C120.295 273.214 120.226 273.2 120.157 273.206C119.368 273.358 118.614 273.661 117.938 274.097Z'
        fill='#316CF4'
      />
      <path
        d='M117.449 274.345C117.402 274.314 117.374 274.261 117.375 274.205C117.383 274.115 117.54 272.249 118.291 271.639C118.469 271.482 118.707 271.41 118.943 271.441C119.184 271.44 119.391 271.61 119.438 271.845C119.57 272.53 118.275 273.957 117.606 274.321H117.532C117.508 274.337 117.478 274.345 117.449 274.345ZM118.489 271.82C118.033 272.403 117.765 273.112 117.721 273.85C118.389 273.347 119.215 272.266 119.133 271.845C119.125 271.804 119.108 271.688 118.91 271.688H118.836C118.708 271.688 118.585 271.736 118.489 271.82Z'
        fill='#316CF4'
      />
      <path
        d='M150.472 273.206H142.591C142.326 273.208 142.096 273.393 142.039 273.652L140.759 279.428C140.65 279.945 140.98 280.453 141.498 280.563C141.567 280.577 141.638 280.584 141.708 280.584C144.258 280.543 146.115 280.386 149.317 280.386C151.289 280.386 157.239 280.592 159.961 280.592C162.685 280.592 163.039 277.903 161.926 277.655C156.924 276.565 153.162 275.055 151.561 273.619C151.265 273.347 150.874 273.199 150.472 273.206Z'
        fill='#0D1333'
      />
      <path
        d='M150.926 274.106C150.864 274.09 150.819 274.037 150.811 273.974C150.8 273.913 150.831 273.853 150.885 273.825C151.116 273.676 153.212 272.389 153.93 272.76C154.095 272.838 154.199 273.006 154.194 273.189C154.237 273.501 154.116 273.813 153.872 274.014C153.507 274.262 153.068 274.379 152.627 274.344C152.052 274.328 151.482 274.248 150.926 274.106ZM151.371 273.89C152.128 274.146 152.954 274.105 153.682 273.775C153.837 273.636 153.915 273.429 153.888 273.222C153.88 273.098 153.831 273.041 153.789 273.041C153.728 273.008 153.66 272.993 153.591 273C152.801 273.152 152.048 273.454 151.371 273.89Z'
        fill='#316CF4'
      />
      <path
        d='M150.883 274.138C150.836 274.107 150.808 274.054 150.809 273.997C150.817 273.907 150.973 272.042 151.725 271.43C151.903 271.274 152.141 271.202 152.377 271.232C152.618 271.231 152.825 271.401 152.872 271.636C153.004 272.321 151.709 273.749 151.04 274.111H150.965C150.941 274.13 150.912 274.139 150.883 274.138ZM151.922 271.613C151.466 272.196 151.198 272.904 151.155 273.642C151.823 273.139 152.649 272.058 152.566 271.638C152.558 271.596 152.542 271.481 152.343 271.481H152.269C152.142 271.482 152.018 271.528 151.922 271.613Z'
        fill='#316CF4'
      />
      <path
        opacity='0.2'
        d='M144.331 260.212L151.025 260.919L150.372 268.366L143.678 267.659L144.331 260.212Z'
        fill='#0D1333'
      />
      <path
        opacity='0.2'
        d='M110.199 259.145H116.693L116.413 266.893H109.918L110.199 259.145Z'
        fill='#0D1333'
      />
      <path
        d='M112.872 127.327H147.302C150.576 145.204 160.823 208.464 153.472 264.829L141.816 263.383C141.816 263.383 142.895 188.556 132.603 160.893C131.42 175.698 130.014 191.45 128.793 199.832C125.798 220.463 119.386 265.549 119.386 265.549H107.52C107.52 265.549 109.945 222.394 111.068 202.118C112.294 180.107 112.824 131.848 112.872 127.327Z'
        fill='#0D1333'
      />
      <path
        opacity='0.2'
        d='M132.607 160.901C134.126 164.977 135.388 170.068 136.453 175.795C137.416 162.621 133.565 148.648 133.565 148.648L132.607 160.901Z'
        fill='#0D1333'
      />
      <path
        d='M154.8 267.547L140.373 265.4L140.814 261.405L155.821 263.375L154.8 267.547Z'
        fill='#316CF4'
      />
      <path
        opacity='0.6'
        d='M154.8 267.547L140.373 265.4L140.814 261.405L155.821 263.375L154.8 267.547Z'
        fill='white'
      />
      <path
        d='M120.809 265.648H106.812V261.464L121.337 261.192L120.809 265.648Z'
        fill='#316CF4'
      />
      <path
        opacity='0.6'
        d='M120.809 265.648H106.812V261.464L121.337 261.192L120.809 265.648Z'
        fill='white'
      />
      <path
        d='M112.137 140.215V143.933L150.275 142.074V138.711L112.137 140.215Z'
        fill='#316CF4'
      />
      <path
        d='M173.443 103.126C173.443 103.126 173.223 104.9 176.072 106.455H179.711C179.711 106.455 181.135 107.299 182.085 107.259C183.035 107.219 187.59 103.851 188.415 103.126C189.24 102.4 186.991 94.249 186.991 94.249L173.443 103.126Z'
        fill='#B97964'
      />
      <path
        d='M144.166 67.6913C144.166 67.6913 122.264 66.6256 105.947 70.7443C105.947 70.7443 111.22 117.98 111.249 139.681C111.251 140.629 112.035 141.381 112.982 141.348L149.767 140.067C150.694 140.035 151.418 139.261 151.384 138.335C151.053 129.366 149.242 86.6903 144.166 67.6913Z'
        fill='#316CF4'
      />
      <path
        opacity='0.2'
        d='M151.383 138.335C151.415 139.264 150.694 140.032 149.766 140.064L112.98 141.344C112.036 141.384 111.252 140.632 111.252 139.68C111.244 135.263 111.02 129.783 110.668 123.862C110.5 121.19 110.316 118.43 110.108 115.63C109.876 112.35 109.612 109.021 109.34 105.741C108.715 98.2525 108.035 90.996 107.443 85.0516C106.595 76.563 105.947 70.7465 105.947 70.7465C122.26 66.6262 144.166 67.6903 144.166 67.6903C149.238 86.6917 151.055 129.367 151.383 138.335Z'
        fill='#0D1333'
      />
      <path
        d='M118.395 68.5317C121.555 71.4031 129.298 70.3414 129.298 70.3414C129.298 70.3414 134.131 69.0181 133.116 67.5084C130.269 67.038 128.89 65.7091 128.321 64.0098C127.991 63.0193 127.941 61.9056 128.032 60.7583C128.074 60.1559 128.164 59.5454 128.271 58.943L118.699 51.8545C119.954 56.5332 121.488 65.1402 118.395 68.5317Z'
        fill='#B97964'
      />
      <path
        opacity='0.2'
        d='M120.914 56.3608C121.294 62.1045 126.014 63.6886 128.324 64.0102C127.995 63.0197 127.944 61.906 128.035 60.7588L120.914 56.3608Z'
        fill='#0D1333'
      />
      <path
        d='M137.428 38.2051C137.428 38.2051 138.787 47.1449 134.042 50.5827C129.297 54.0214 129.297 37.3794 129.297 37.3794L137.428 38.2051Z'
        fill='#0D1333'
      />
      <path
        d='M120.26 57.6938C122.562 61.0028 126.317 61.8693 129.576 60.838C131.673 60.1779 133.562 58.725 134.734 56.6377C134.89 56.3657 135.03 56.0769 135.163 55.7792C137.498 50.3164 138.24 40.7605 132.464 37.1795C128.363 34.5969 122.933 35.8266 120.35 39.9357C119.608 41.099 119.162 42.4279 119.03 43.8056C118.32 50.1924 117.603 53.9143 120.26 57.6938Z'
        fill='#B97964'
      />
      <path
        d='M128.346 47.2168C128.223 47.7216 128.455 48.1945 128.799 48.2529C129.141 48.3105 129.48 47.9345 129.57 47.4216C129.661 46.9088 129.452 46.4415 129.117 46.3855C128.783 46.3295 128.439 46.6952 128.346 47.2168Z'
        fill='#0D1333'
      />
      <path
        d='M134.177 48.2101C134.054 48.7149 134.296 49.1901 134.63 49.2461C134.964 49.3021 135.311 48.9277 135.401 48.4149C135.492 47.902 135.284 47.4348 134.948 47.3788C134.614 47.3228 134.262 47.7212 134.177 48.2101Z'
        fill='#0D1333'
      />
      <path
        d='M132.277 48.1509C132.622 49.8334 133.197 51.4591 133.987 52.984C133.183 53.3745 132.247 53.3889 131.43 53.0232L132.277 48.1509Z'
        fill='#A24E3F'
      />
      <path
        d='M126.867 45.016C126.976 45.0512 127.095 45.0248 127.18 44.948C127.737 44.4 128.519 44.1463 129.292 44.2647C129.456 44.3048 129.62 44.2047 129.661 44.0415C129.701 43.8775 129.601 43.7127 129.438 43.6719H129.436C128.464 43.4975 127.467 43.8055 126.763 44.4984C126.637 44.6104 126.625 44.8032 126.737 44.9296C126.739 44.9312 126.74 44.9336 126.742 44.9352C126.779 44.968 126.821 44.9952 126.867 45.016Z'
        fill='#0D1333'
      />
      <path
        d='M130.141 55.5489C128.605 55.5201 127.179 54.7441 126.32 53.4696C126.276 53.392 126.302 53.2928 126.378 53.2464C126.451 53.2 126.548 53.2208 126.595 53.2936C126.597 53.2968 126.599 53.3008 126.601 53.304C127.419 54.4665 128.737 55.1761 130.157 55.2185C130.244 55.2177 130.314 55.2881 130.315 55.3745C130.315 55.3801 130.315 55.3865 130.314 55.3921C130.315 55.4785 130.245 55.549 130.158 55.5498C130.153 55.5498 130.147 55.5497 130.141 55.5489Z'
        fill='#0D1333'
      />
      <path
        d='M137.027 46.627C137.08 46.6598 137.141 46.6742 137.203 46.6702C137.365 46.6254 137.461 46.4574 137.416 46.295C137.416 46.2926 137.416 46.291 137.415 46.2886C137.16 45.3309 136.455 44.5572 135.525 44.2148C135.363 44.166 135.193 44.2572 135.144 44.418C135.099 44.5796 135.19 44.7477 135.348 44.8005C136.075 45.0925 136.62 45.7101 136.82 46.467C136.862 46.5478 136.938 46.6062 137.027 46.627Z'
        fill='#0D1333'
      />
      <path
        d='M125.03 36.6966V39.5496C124.048 39.928 123.365 40.9009 123.655 42.0602C124.274 44.5356 122.484 48.0398 120.491 49.2807C120.491 49.2807 120.56 48.2494 119.666 48.3862C118.773 48.5239 118.36 53.8874 119.735 56.638C119.735 56.638 117.466 54.0251 116.709 48.2486C116.01 42.9067 116.371 38.5695 117.68 36.6958L125.03 36.6966Z'
        fill='#0D1333'
      />
      <path
        d='M115.381 48.5212C115.839 50.0741 116.894 51.3822 118.315 52.1582C120.204 53.1727 121.615 51.5942 121.487 49.5652C121.356 47.7635 120.236 45.0081 118.144 44.8505C116.052 44.6921 114.844 46.6074 115.381 48.5212Z'
        fill='#B97964'
      />
      <path
        d='M125.031 39.5491C125.031 39.5491 126.886 41.3868 128.684 40.0411C128.684 40.0411 130.72 41.738 132.382 40.5331C132.382 40.5331 133.291 42.0717 134.782 42.2565C136.273 42.4413 136.278 40.9028 136.278 40.9028C136.278 40.9028 138.633 42.2565 139.503 41.6236C140.374 40.9908 139.029 38.4586 139.029 38.4586C139.029 38.4586 140.137 37.861 139.425 35.8256C138.713 33.7903 135.421 34.2647 135.421 34.2647C135.421 34.2647 135.548 32.3654 133.253 30.3876C130.959 28.4091 129.591 30.862 129.591 30.862C129.591 30.862 127.368 27.8554 124.613 28.2507C121.859 28.6459 122.176 30.5452 122.176 30.5452C122.176 30.5452 119.011 28.5667 117.587 30.5452C116.162 32.5238 117.587 33.4726 117.587 33.4726C117.587 33.4726 114.422 34.5351 114.58 36.6945C114.738 38.853 116.362 38.537 116.362 38.537C116.362 38.537 115.45 39.5659 117.508 40.4363C119.565 41.3068 121.496 39.1706 121.496 39.1706C121.496 39.1706 120.696 40.3963 122.177 41.2276C123.656 42.0597 125.031 39.5491 125.031 39.5491Z'
        fill='#0D1333'
      />
      <path
        d='M129.3 70.3441C129.3 70.3441 118.134 62.7572 114.578 62.3315C111.023 61.9059 111.656 66.3382 111.656 66.3382C111.656 66.3382 108.913 66.3374 109.968 69.7137C111.023 73.0899 126.191 74.9516 131.795 73.2819C137.398 71.6122 140.728 68.4696 139.802 65.5046C138.875 62.5396 136.283 65.0797 136.283 65.0797C136.283 65.0797 134.776 62.2859 132.606 62.9404C130.436 63.594 129.3 70.3441 129.3 70.3441Z'
        fill='#316CF4'
      />
      <path
        d='M127.65 73.2788C130.899 78.8816 125.921 85.2493 128.44 91.0457'
        stroke='white'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M132.719 72.1411C132.719 72.1411 135.581 74.4469 136.913 79.4128C138.245 84.3796 136.241 89.3912 136.241 89.3912'
        stroke='white'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M125.04 117.754L126.662 118.614C126.662 118.614 124.942 130.957 120.917 133.648L119.266 131.748C119.266 131.748 124.96 124.333 125.04 117.754Z'
        fill='#316CF4'
      />
      <path
        d='M145.333 116.711L143.316 117.752C143.316 117.752 147.047 129.688 149.454 132.378L150.828 130.479C150.828 130.479 146.241 122.883 145.333 116.711Z'
        fill='#316CF4'
      />
      <path
        opacity='0.2'
        d='M124.837 110.433C124.837 110.433 119.677 120.898 110.66 123.858C110.492 121.186 110.308 118.426 110.1 115.626C109.868 112.345 109.604 109.017 109.332 105.737L124.837 110.433Z'
        fill='#0D1333'
      />
      <path
        d='M131.789 102.331L142.193 98.8289C142.193 98.8289 151.53 90.5083 153.587 90.5539C155.644 90.5995 157.385 95.8183 158.335 97.7984C159.285 99.7786 149.523 103.796 148.073 104.637C146.624 105.476 144.607 104.637 144.607 104.637L133.989 109.274L131.789 102.331Z'
        fill='#B97964'
      />
      <path
        d='M105.95 70.7437C96.2576 72.0317 101.278 108.536 107.524 115.71C112.741 121.703 131.77 112.901 137.897 109.838C139.002 109.286 139.529 108.004 139.138 106.832L137.347 101.46C136.935 100.224 135.644 99.5145 134.381 99.837C129.22 101.152 116.775 104.099 115.263 102.332C113.349 100.096 110.817 89.1298 111.239 82.1637C111.66 75.1968 105.95 70.7437 105.95 70.7437Z'
        fill='#316CF4'
      />
      <path
        d='M135.836 99.917L139.169 108.272L142.156 106.457L139.263 99.105L135.836 99.917Z'
        fill='#316CF4'
      />
      <path
        opacity='0.3'
        d='M135.836 99.917L139.169 108.272L142.156 106.457L139.263 99.105L135.836 99.917Z'
        fill='#0D1333'
      />
      <g clipPath='url(#clip0_36_31988)'>
        <path
          d='M274.643 3.10356V233.482C274.643 235.376 273.12 236.848 271.225 236.848H164.009C163.156 236.848 162.406 236.528 161.866 235.988C161.298 235.435 160.955 234.647 160.955 233.759V2.82674C160.955 1.31783 162.063 -0.000665226 163.571 -0.000665226H194.019C194.879 -0.000665226 195.658 0.560179 195.98 1.36984L197.241 4.47406C197.562 5.27572 198.341 5.82936 199.201 5.82936H236.463C237.323 5.82936 238.103 5.29732 238.423 4.49566L239.684 1.37623C240.005 0.567376 240.785 -0.00146484 241.644 -0.00146484H271.654C273.317 -0.000664786 274.643 1.44184 274.643 3.10356Z'
          fill='#316CF4'
        />
      </g>
      <g clipPath='url(#clip1_36_31988)'>
        <path
          opacity='0.4'
          d='M279.438 3.10356V233.482C279.438 235.376 277.915 236.848 276.02 236.848H168.804C167.951 236.848 167.201 236.528 166.661 235.988C166.093 235.435 165.75 234.647 165.75 233.759V2.82674C165.75 1.31783 166.858 -0.000665225 168.366 -0.000665225H198.814C199.674 -0.000665225 200.453 0.560179 200.775 1.36984L202.036 4.47406C202.357 5.27572 203.136 5.82936 203.996 5.82936H241.258C242.118 5.82936 242.898 5.29732 243.218 4.49566L244.479 1.37623C244.8 0.567376 245.58 -0.00146484 246.439 -0.00146484H276.449C278.112 -0.000664786 279.438 1.44184 279.438 3.10356Z'
          fill='white'
        />
      </g>
      <path
        d='M186.545 175.658H258.65C260.897 175.658 262.72 177.48 262.72 179.727C262.72 181.975 260.898 183.797 258.65 183.797H186.545C184.297 183.797 182.475 181.975 182.475 179.727C182.475 177.48 184.296 175.658 186.545 175.658Z'
        fill='#316CF4'
      />
      <path
        opacity='0.3'
        d='M186.545 175.658H258.65C260.897 175.658 262.72 177.48 262.72 179.727C262.72 181.975 260.898 183.797 258.65 183.797H186.545C184.297 183.797 182.475 181.975 182.475 179.727C182.475 177.48 184.296 175.658 186.545 175.658Z'
        fill='#0D1333'
      />
      <path
        d='M209.858 176.39C211.699 176.39 213.199 177.889 213.199 179.731C213.199 181.574 211.7 183.072 209.858 183.072H186.548C184.706 183.072 183.207 181.574 183.207 179.731C183.207 177.889 184.706 176.39 186.548 176.39H209.858Z'
        fill='#316CF4'
      />
      <path
        d='M203.372 54.5091C202.673 54.5091 202.08 54.2659 201.594 53.7786C201.107 53.2922 200.863 52.7018 200.863 52.0081V43.8779H202.415V51.9913C202.415 52.2433 202.505 52.457 202.684 52.633C202.863 52.809 203.079 52.8978 203.331 52.8978C203.583 52.8978 203.796 52.8098 203.972 52.633C204.148 52.457 204.236 52.2433 204.236 51.9913V43.8779H205.889V52.0081C205.889 52.713 205.643 53.3058 205.151 53.7874C204.659 54.2683 204.066 54.5091 203.372 54.5091Z'
        fill='#316CF4'
      />
      <path
        d='M209.796 43.8779C210.568 43.8779 211.184 44.1211 211.643 44.6084C212.068 45.0732 212.28 45.6653 212.28 46.3869V47.9142C212.28 48.6079 212.038 49.2007 211.555 49.6927C211.071 50.1856 210.485 50.4312 209.797 50.4312H208.883V54.3915H207.297V43.8779H209.796ZM210.744 46.4125C210.744 46.1381 210.662 45.9173 210.497 45.7493C210.331 45.5813 210.112 45.498 209.839 45.498H208.882V48.8623H209.839C210.091 48.8623 210.304 48.7727 210.48 48.5935C210.656 48.4143 210.744 48.199 210.744 47.947V46.4125Z'
        fill='#316CF4'
      />
      <path
        d='M215.894 54.5283C215.195 54.5283 214.6 54.2819 214.111 53.7898C213.622 53.2978 213.377 52.7073 213.377 52.0193V46.2805C213.377 45.5812 213.623 44.9868 214.115 44.4971C214.607 44.0075 215.201 43.7627 215.894 43.7627C216.593 43.7627 217.186 44.0091 217.673 44.5012C218.16 44.9932 218.403 45.586 218.403 46.2797V47.479H216.759V46.2461C216.759 45.9941 216.669 45.7788 216.49 45.5996C216.311 45.4204 216.096 45.3308 215.844 45.3308C215.592 45.3308 215.378 45.4204 215.202 45.5996C215.026 45.7788 214.938 45.9941 214.938 46.2461V52.0017C214.938 52.2529 215.026 52.4673 215.202 52.6433C215.378 52.8193 215.592 52.9074 215.844 52.9074C216.096 52.9074 216.311 52.8202 216.49 52.6441C216.669 52.4681 216.759 52.2553 216.759 52.0041V49.9375H215.877V48.3438H218.403V52.0185C218.403 52.7177 218.157 53.3106 217.664 53.797C217.172 54.2843 216.582 54.5283 215.894 54.5283Z'
        fill='#316CF4'
      />
      <path
        d='M222.278 43.8779C223.162 43.8779 223.811 44.1211 224.225 44.6084C224.589 45.0332 224.771 45.6261 224.771 46.3869V47.9142C224.771 48.6583 224.488 49.2871 223.923 49.8024L225.098 54.3915H223.382L222.421 50.4312C222.376 50.4312 222.328 50.4312 222.278 50.4312H221.363V54.3915H219.777V43.8779H222.278ZM223.226 46.4125C223.226 45.8029 222.925 45.498 222.321 45.498H221.364V48.8623H222.321C222.572 48.8623 222.786 48.7727 222.962 48.5935C223.138 48.4143 223.226 48.199 223.226 47.947V46.4125Z'
        fill='#316CF4'
      />
      <path
        d='M228.409 51.9748L228.024 54.391H226.373L228.16 43.8774H230.342L232.104 54.391H230.437L230.065 51.9748H228.409ZM229.242 46.2864L228.655 50.4315H229.829L229.242 46.2864Z'
        fill='#316CF4'
      />
      <path
        d='M238.418 51.8757C238.418 52.5693 238.175 53.1622 237.688 53.6542C237.201 54.1462 236.614 54.3927 235.926 54.3927H233.434V43.8711H235.926C236.619 43.8711 237.208 44.1175 237.692 44.6096C238.176 45.1016 238.418 45.692 238.418 46.3801V51.8757ZM235.019 52.8237H235.976C236.228 52.8237 236.44 52.7325 236.614 52.5509C236.787 52.3693 236.874 52.1549 236.874 51.9093V46.4049C236.874 46.1537 236.786 45.9384 236.609 45.7584C236.433 45.5792 236.222 45.4904 235.975 45.4904H235.019L235.019 52.8237Z'
        fill='#316CF4'
      />
      <path
        d='M239.807 54.3927V43.8711H244.321V45.4656H241.392V48.3346H243.532V49.9291H241.392V52.7981H244.321V54.3927H239.807Z'
        fill='#316CF4'
      />
      <g opacity='0.1'>
        <path
          d='M216.9 5.83002L184.172 128.423V128.43L183.808 129.808V129.815L183.217 132.023V132.03L182.845 133.408L165.756 197.423V119.948L197.778 0H198.82C199.68 0 200.459 0.560845 200.781 1.3705L202.042 4.47473C202.362 5.27638 203.142 5.83002 204.002 5.83002H216.9Z'
          fill='white'
        />
        <path
          d='M279.446 68.4375V145.913L259.033 222.375L258.537 224.233L255.171 236.848H234.488L237.855 224.241L238.394 222.214L241.098 212.085L241.638 210.059L242.723 206.007L243.262 203.981L244.341 199.929L244.88 197.903L261.897 134.172V134.165L262.684 131.22V131.213L279.446 68.4375Z'
          fill='white'
        />
        <path
          d='M228.11 5.83105L195.585 127.659L195.388 128.388L193.61 135.064L193.413 135.792L166.667 235.991C166.099 235.437 165.756 234.65 165.756 233.761V221.977L188.763 135.793L188.96 135.064L190.738 128.389L190.935 127.66L223.46 5.83185L228.11 5.83105Z'
          fill='white'
        />
      </g>
      <path
        d='M257.705 112.993C257.705 129.915 245.729 144.044 229.791 147.364C227.471 147.844 225.063 148.1 222.599 148.1C220.135 148.1 217.727 147.844 215.406 147.364C199.461 144.044 187.484 129.915 187.484 112.993C187.484 93.6 203.205 77.8789 222.599 77.8789C241.984 77.8789 257.705 93.6 257.705 112.993Z'
        fill='#316CF4'
      />
      <path
        opacity='0.6'
        d='M240.622 110.073H231.109C230.381 110.073 229.789 110.665 229.789 111.393V147.363C227.469 147.843 225.061 148.099 222.596 148.099C220.132 148.099 217.724 147.843 215.404 147.363V111.393C215.404 110.665 214.812 110.073 214.076 110.073H204.563C203.387 110.073 202.795 108.64 203.627 107.808L221.66 89.7831C222.172 89.2631 223.013 89.2631 223.533 89.7831L241.558 107.808C242.398 108.64 241.806 110.073 240.622 110.073Z'
        fill='white'
      />
      <defs>
        <clipPath id='clip0_36_31988'>
          <path
            d='M161 10.9311C161 9.2743 162.343 7.93115 164 7.93115H271.758C273.415 7.93115 274.758 9.2743 274.758 10.9312V236.698H161V10.9311Z'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip1_36_31988'>
          <path
            d='M165.996 10.9311C165.996 9.2743 167.339 7.93115 168.996 7.93115H271.754C273.411 7.93115 274.754 9.2743 274.754 10.9312V236.698H165.996V10.9311Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
